import React from 'react';
import './BookCard.css';

const BookCard = ({ book }) => {
  return (
    <div className="book-card">
      <div className="book-info">
        <h3>{book.title}</h3>
        <p>{book.author}</p>
      </div>
      <div className="book-controls">
        <audio controls src={book.audioUrl}>
          Your browser does not support the audio element.
        </audio>
      </div>
    </div>
  );
};

export default BookCard;
